import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  header: drilldownData["header"].map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  appAbout: drilldownData["appAbout"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  appCardsListContent: drilldownData["appCardsListContent"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  appCardsMainContent: drilldownData["appCardsMainContent"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  appHeader: drilldownData["appHeader"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
    })
  ),
};
